import { Button, Col, Form, List, Row, Space, Spin, Tabs, TabsProps, Tooltip, Upload, message } from "antd";
import { InputFields, ModalCustom } from "components/common";
import React, { useEffect, useRef, useState } from "react";
//import { dataFieldss } from "./InfoDocArrive/Configg";
import { employeeService } from "api";
import Notification from "components/common/notification/notification";
import dayjs from "dayjs";
import { DeleteOutlined, DownloadOutlined, EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { FORMAT_TIME } from "types/enums";
import InfoDocArrive from "./InfoDocArrive/InfoDocArrive";
import ListFileArrive from "./ListFileArrive/ListFileArrive";
import { useAppSelector } from "redux/hooks";
const FormTextArrive = (props) => {
  const { data, closeModal, type, getList } = props;
  const [form] = Form.useForm();
  const detailDocc = useAppSelector(state => state.employeesReducer.detailDoc);
  const [activeKeys, setActiveKeys] = useState<string>("info-doc-arrive");
  const itemsInitt: TabsProps["items"] = [
    {
      key: "info-doc-arrive",
      label: `Thông tin văn bản`,
      children: <InfoDocArrive type={type} closeModal={closeModal} getList={getList} />,
    },
    {
      key: "list-file-arrive",
      label: `Danh sách file`,
      children: (
        <ListFileArrive closeModal={closeModal} getList={getList} activeKeys={activeKeys}></ListFileArrive>
      ),
    },
  ];
  const [itemss, setItemss] = useState<TabsProps["items"]>(itemsInitt);
  useEffect(() => {
    const setDisableTab = () => {
      itemsInitt[1].disabled = detailDocc == null;
      setItemss([...itemsInitt]);
    };
    const _setActiveKey = () => {
      setActiveKeys("info-doc-arrive");
    };
    setDisableTab();
    _setActiveKey();
  }, [detailDocc]);
  return (
    <div>
    <Tabs
      items={itemss}
      activeKey={activeKeys}
      onChange={key => {
        setActiveKeys(key);
      }}
    ></Tabs>
  </div>
  )
};

export default FormTextArrive;
